<script setup lang="ts">
import { NewProduct } from '@/types/api/api-v4/product'
import { Slider } from '@/types/api/api-v4/slider'

import MainFactoid from '@/components/Main/MainFactoid.vue'
import ProductCard from '@/components/Product/ProductCard/ProductCard.vue'
import ProductModal from '@/components/Product/ProductModal.vue'

import { SliderOverlay } from '@smenaspace/ui-layer'

type Props = {
  saleSlider: Slider[]
  salesSliderProducts: NewProduct[]
  cityTitle: string
}

const props = defineProps<Props>()

const { productDialog, openDialogProduct, closeDialogProduct } =
  useProductModal()

const { isMobileOrTablet } = useResponsive()

const sliderProperty = computed(() => {
  if (isMobileOrTablet.value) {
    return {
      overlay: 'sm' as SliderOverlay,
      space: 10,
    }
  }

  return {
    overlay: 'md' as SliderOverlay,
    space: 32,
  }
})

const onOpenDialog = (product: NewProduct) => {
  openDialogProduct({
    currentProduct: product,
    productList: props.salesSliderProducts,
    visible: true,
  })
}
</script>

<template>
  <the-slider
    class="landing-slider"
    :overlay="sliderProperty.overlay"
    :space-between="sliderProperty.space"
    :slide-width="276"
    :slides-to-scroll="4"
    :snap="!isMobileOrTablet"
    :arrows="!isMobileOrTablet"
  >
    <main-factoid class="landing-slider__factoid" :city-title="cityTitle" />

    <template v-for="product in salesSliderProducts" :key="product.id">
      <product-card
        class="landing-slider__product"
        :product="product"
        @on-open-dialog="onOpenDialog"
      />
    </template>
  </the-slider>

  <product-modal
    :product-dialog="productDialog"
    @close-dialog-product="closeDialogProduct"
  />
</template>

<style lang="scss" scoped>
.landing-slider {
  &__factoid {
    width: 144px;

    @include media('>=desktop-mini') {
      width: 276px;
      height: 392px;
    }
  }

  &__product {
    width: 144px;
    margin-left: 0;

    @include media('>desktop-mini') {
      width: 276px;
    }
  }
}
</style>
